export default "__VITE_ASSET__YYGv9muv__"